import type { ApiResponse } from '@/types/api';
import type { Business, UpdateBusinessPayload } from '@/types/business';
import { apiClient } from './client';

export async function getProfile(): Promise<ApiResponse<{ business: Business }>> {
  const { data } = await apiClient.get<ApiResponse<{ business: Business }>>('/merchant/business');
  return data;
}

export async function updateProfile(
  payload: UpdateBusinessPayload,
): Promise<ApiResponse<{ business: Business }>> {
  const { data } = await apiClient.put<ApiResponse<{ business: Business }>>(
    '/merchant/business',
    payload,
  );
  return data;
}

export async function uploadLogo(file: File): Promise<ApiResponse<{ business: Business }>> {
  const form = new FormData();
  form.append('logo', file);
  const { data } = await apiClient.post<ApiResponse<{ business: Business }>>(
    '/merchant/business/logo',
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
}

